export const AGREEMENT_QUALIFIED_INVESTOR_FILE_INIT =
  'AGREEMENT_QUALIFIED_INVESTOR_FILE_INIT';
export const AGREEMENT_QUALIFIED_INVESTOR_FILE_SUCCESS =
  'AGREEMENT_QUALIFIED_INVESTOR_FILE_SUCCESS';
export const AGREEMENT_QUALIFIED_INVESTOR_FILE_ERROR =
  'AGREEMENT_QUALIFIED_INVESTOR_FILE_ERROR';
